<template>
  <div>
    <CCol xl="12" lg="12" md="12" style="margin-top: 20%" v-if="Spinner">
      <div
        class="sk-wave primary"
        color="success"
        style="margin: auto; width: 10%; top: 50% !important"
      >
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
      </div>
    </CCol>
    <CCard style="margin-top: 20px" v-else>
      <CCardHeader>
        <div style="margin: auto">
          <DatePicker
            v-model="value1"
            type="date"
            range
            placeholder="Select date range"
            style="float: left"
          ></DatePicker>
        </div>
        &nbsp;&nbsp;
        <CButton
          @click="deleteCollection()"
          color="danger"
          style="text-align: center; margin-left: 20px"
        >
          clear Leaderboard
        </CButton>
        <CButton
          color="success"
          style="margin-left: 15px"
          v-if="tbl2"
          @click="refresh()"
          >Go to all data</CButton
        >
        <JsonCSV
          v-if="tbl1"
          style="background-color: #4638c2; color: white; float: right"
          color="primary"
          class="btn btn-default mb-2 clr"
          :data="tableData"
          name="rage_capture-list.csv"
        >
          Download CSV (This is a slot)
        </JsonCSV>
        <JsonCSV
          v-if="tbl2"
          style="background-color: #4638c2; color: white; float: right"
          color="primary"
          class="btn btn-default mb-2 clr"
          :data="tableData2"
          name="rage_capture-list.csv"
        >
          Download CSV (This is a slot)
        </JsonCSV>
      </CCardHeader>

      <CCardBody>
        <CDataTable
          v-if="tbl1"
          :items="tableData"
          :fields="fields"
          column-filter
          table-filter
          items-per-page-select
          :items-per-page="10"
          hover
          sorter
          pagination
        >
          <template #hash="{ item }">
            <td>
              {{ item.hash.substring(0, 10) + "..." }}
            </td>
          </template>
        </CDataTable>
        <CDataTable
          v-if="tbl2"
          :items="tableData2"
          :fields="fields"
          column-filter
          table-filter
          items-per-page-select
          :items-per-page="10"
          hover
          sorter
          pagination
        >
          <template #hash="{ item }">
            <td>
              {{ item.hash.substring(0, 10) + "..." }}
            </td>
          </template>
        </CDataTable>
      </CCardBody>
    </CCard>
  </div>
</template>
<style src="spinkit/spinkit.min.css"></style>
<script>
import firebase from "firebase";
const db = firebase.firestore();
import Swal from "sweetalert2";
import moment from "moment";
import JsonCSV from "vue-json-csv";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { secondaryDatabase } from "./secondary.js";
export default {
  components: {
    JsonCSV,
    DatePicker,
  },
  data() {
    return {
      activeTab: 1,
      value1: [],
      tbl1: true,
      tbl2: false,
      Spinner: false,
      tableData: [],
      userdata: [],
      tableData2: [],
      fields: [
        {
          label: "Date",
          key: "date",
          sortable: true,
        },

        {
          label: "Email",
          key: "email",
          sortable: true,
        },
        {
          label: "EthAddress",
          key: "ethAddress",
          sortable: true,
        },

        {
          label: "TeamName",
          key: "teamName",
          sortable: true,
        },
        {
          label: "Quiz Points",
          key: "quizpoint",
          sortable: true,
        },
      ],
    };
  },
  watch: {
    value1() {
      var res = new Date(this.value1[1]);
      res.setDate(res.getDate() + 1);

      let v1 = firebase.firestore.Timestamp.fromDate(new Date(this.value1[0]));
      let v2 = firebase.firestore.Timestamp.fromDate(new Date(res));

      this.tableData = [];
      secondaryDatabase
        .collection("leaderboardQuiz")
        .where("created", ">=", v1)
        .where("created", "<=", v2)
        .orderBy("lastUpdate", "desc")
        .get()
        .then((snapshot) => {
          this.tableData2 = [];
          snapshot.forEach((doc) => {
            let backenddate = moment(doc.data().created.seconds * 1000).format(
              "DD-MMM-YYYY"
            );

            this.tableData.push({
              Id: doc.id,
              email: doc.data().email,
              ethAddress: doc.data().ethAddress,
              quizpoint: doc.data().quizpoint,
              teamName: doc.data().teamName,
              date: backenddate,
            });
          });
        });
    },
  },
  methods: {
    refresh() {
      window.location.reload();
      // this.tbl1=true;
      //  this.tbl2=false;
    },
    async deleteCollection() {
      //  db, collectionPath, batchSize
      this.Spinner = true;
      const collectionRef = secondaryDatabase.collection("leaderboardQuiz");
      const query = collectionRef.limit(100);

      return new Promise((resolve, reject) => {
        this.deleteQueryBatch(secondaryDatabase, query, resolve).catch(reject);
      });
    },

    async deleteQueryBatch(secondaryDatabase, query, resolve) {
      const snapshot = await query.get();

      const batchSize = snapshot.size;
      if (batchSize === 0) {
        this.Spinner = false;
        // When there are no documents left, we are done
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Data cleaned successfully",
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
        resolve();
        return;
      }

      // Delete documents in a batch
      const batch = secondaryDatabase.batch();
      snapshot.docs.forEach(async (doc) => {
        batch.delete(doc.ref);
      });
      await batch.commit();

      // Recurse on the next process tick, to avoid
      // exploding the stack.
      process.nextTick(() => {
        this.deleteQueryBatch(secondaryDatabase, query, resolve);
      });
    },

    getmessage() {
      secondaryDatabase
        .collection("leaderboardQuiz")
        .orderBy("lastUpdate", "desc")
        .get()
        .then((snapshot) => {
          this.tbl1 = true;
          this.tbl2 = false;
          snapshot.forEach((doc) => {
            let backenddate = moment(
              doc.data().lastUpdate.seconds * 1000
            ).format("DD-MMM-YYYY");

            this.tableData.push({
              Id: doc.id,
              email: doc.data().email,
              ethAddress: doc.data().ethAddress,
              quizpoint: doc.data().quizpoint,
              teamName: doc.data().teamName,
              date: backenddate,
            });
          });
        });
    },

    rowClicked(item, index, column, e) {
      this.documentId = item.id;
    },

    deleteRoute(item) {
      this.documentId = item.id;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          width: "600px",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            );
            this.deletecompanyDetails();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    deletecompanyDetails(item) {
      db.collection("messagetest")
        .doc(this.documentId)
        .delete()
        .then(() => {
          this.getmessage();
          window.location.reload();
        })
        .catch((error) => {
          console.error("Error removing document: ", error);
        });
    },
    // sendmsg(){}
  },
  created() {
    this.getmessage();
    // this.sendmsg();
  },
};
</script>
<style >
.swal2-cancel {
  margin: 10px !important;
}
.sk-wave-rect {
  background-color: #4638c2;
  height: 100%;
  width: 15%;
  -webkit-animation: sk-wave 1.2s ease-in-out infinite;
  animation: sk-wave 1.2s ease-in-out infinite;
}
</style>